/**
 * Publication Price Changed Renderer
 *
 * Displays price change batch process details:
 * operation description and total publications count.
 */

import { FC } from 'react';
import { Group, Stack, Text } from '@mantine/core';
import type { DetailRendererProps, OperationRendererConfig } from './index';

const DetailComponent: FC<DetailRendererProps> = ({ process, t }) => {
  const totalItems = process.totalItems ?? 0;

  return (
    <Stack gap="sm">
      <Text fz="sm" c="dimmed">
        {t( 'batchProcesses_operations_PublicationPriceChanged_description' )}
      </Text>

      <Group gap="xs">
        <Text fz="sm" fw={500}>
          {t( 'batchProcesses_renderer_publicationCount' )}:
        </Text>
        <Text fz="sm">
          {totalItems}
        </Text>
      </Group>
    </Stack>
  );
};

export const config: Omit<OperationRendererConfig, 'icon' | 'color' | 'labelKey'> = {
  getSummary: ( _data, t ) => t( 'batchProcesses_summary_priceChange' ),
  DetailComponent,
  getRequiredReferenceIds: () => ({})
};

export default DetailComponent;
